import {useContext, useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {HeaderToggleContext} from "../../App";
import {getServer, GoogleAnalyticsButton} from "../../misc";
import {useLocationPathname} from "../../hooks/useLocationPathname";


export default function LinkButton(props) {
    const pathname = useLocationPathname();
    const {changeToggle, setChangeToggle} = useContext(HeaderToggleContext);
    const [server, setServer] = useState(getServer());

    useEffect(() => {
        setServer(getServer());
    }, [pathname]);

    const linkAction = () => {
        GoogleAnalyticsButton()
        setChangeToggle(!changeToggle)
        document.querySelector('#burgerButton').click()
        window.scrollTo(0, 0)
        document.querySelector('.my-header').classList.remove('hide-header')
    }


    return (
        <li id={props.matomo_id} className={`${window.location.pathname.split('/')[1] === props.to ? 'active' : ''}`} onClick={() => {
            linkAction()
        }}>
            <Link to={`/${server}/${props.to}`} className={`link-effect-4 ready`}>
                <span className={`link-effect-inner`}>
                    <span className={`link-effect-l`}>
                        <span>{props.children}</span>
                    </span>
                    <span className={`link-effect-r`}>
                        <span>{props.children}</span>
                    </span>
                    <span className={`link-effect-shade`}>
                        <span>{props.children}</span>
                    </span>
                </span>
            </Link>
        </li>
    )
}